import { render } from "./Marketplace.vue?vue&type=template&id=5c57e52c"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"
script.render = render

export default script